import { useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import http from "../../common/http-common";
import * as common from "../../common/common";
import * as Comp from "../../common/CommonComponents";
import { GetPagePermissionFn } from "../../common/authority";
import CssClass from "../../Styles/common.module.css";
import SystemListTable from "../../components/MasterSetup/System/SystemListTable";
import RegisterSystem from "../../components/MasterSetup/System/RegisterSystem";
import register from "../../assets/register-icon.png";
import exportIcon from "../../assets/export-icon.png";

const PAGE_NAME = "System.js";
const MODULE_ID = "WEB_MAS_003";

const System = (props) => {
  document.title = common.c_TITLE + " - System";

  const navigate = useNavigate();
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);

  const [searchData, setSearchData] = useState([]);
  const [allData, setAllData] = useState([]);

  const [dataToBeSelect, setDataToBeSelect] = useState([]);

  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("Loading...");
  const [reload, setReload] = useState(false);

  const [showAdd, setShowAdd] = useState(false);

  const [actionAuthority, setActionAuthority] = useState({
    READ: "N",
    WRITE: "N",
  });

  useEffect(() => {
    let promise = GetPagePermissionFn(userId, MODULE_ID);
    promise.then(
      (result) => {
        setActionAuthority(result);
        if (result.READ === "N") {
          navigate("/Home");
        }
      },
      (error) => {
        setActionAuthority({
          READ: "N",
          WRITE: "N",
        });
        common.c_LogWebError(PAGE_NAME, "GetPagePermissionFn", error);
        toast.error(error);
        navigate("/Home");
      }
    );
  }, [userId, navigate]);

  useEffect(() => {
    if (actionAuthority.READ === "Y") {
      let functionName = "";

      try {
        functionName = "useEffect Get All System";

        onLoadingHandler(true, "Getting System List, please wait...");

        setAllData([]);
        const listItems = [];
        http
          .get("api/SystemSetup/GetAllSystem?_userId=" + userId, {
            timeout: 10000000,
          })
          .then((response) => {
            if (response.data.length > 0) {
              response.data.forEach((data, counter) => {
                listItems.push({
                  key: data.SYSTEM_MST_ID,
                  SYSTEM_MST_ID: data.SYSTEM_MST_ID,
                  SYSTEM_MST_NAME: data.SYSTEM_MST_NAME,
                  REMARK: data.REMARK,
                  ACTIVE_FLAG: data.ACTIVE_FLAG,
                  STATUS: data.ACTIVE_FLAG === "Y" ? "Active" : "Inactive",
                  // ORG_SYSTEM_ID: data.ORG_SYSTEM_ID,
                  // ORGANIZATION_SYSTEM: data.ORGANIZATION_SYSTEM,
                  UPDATE_DATETIME: data.UPDATE_DATETIME,
                  UPDATE_ID: data.UPDATE_ID,
                  UPDATE_NAME: data.UPDATE_NAME,
                  ATTACHMENT_NAME: data.ATTACHMENT_NAME,
                });
              });
            }
            setAllData(listItems);
          })
          .catch((err) => {
            toast.error("Error on getting system list. Please try again.");
            common.c_LogWebError(PAGE_NAME, functionName, err);
          })
          .finally(() => {
            onLoadingHandler(false, "Loading...");
          });
      } catch (err) {
        toast.error("Error on getting system list. Please try again.");
        common.c_LogWebError(PAGE_NAME, functionName, err);
      }
    }
  }, [reload, actionAuthority, userId]);

  //#region Event Handlers
  const showHideRegisterModal = () => {
    setShowAdd(!showAdd);
  };

  const onReloadHandler = () => {
    setReload(!reload);
  };

  const onLoadingHandler = (load, text) => {
    setLoading(load);
    setLoadingText(text);
  };

  const onExcelHandler = () => {  
      window.open(common.c_getApiUrl() + "api/SystemSetup/ExportExcel?_user=" + userId);
  }
  //#endregion

  return (
    <>
      <Comp.Header>System</Comp.Header>
      <div className={CssClass.btnWrapper}>
        {actionAuthority.WRITE === "Y" && (
          <Comp.Button
            id="btnRegister"
            type="general"
            onClick={showHideRegisterModal}
          >
            REGISTER  <img src={register} alt="Register" style={{ width: "16px", height: "16px", marginBottom: "3px" }} />
          </Comp.Button>
        )} 
        <Comp.Button id="btnExcel" type="excel" onClick={onExcelHandler}>
          EXPORT  <img src={exportIcon} alt="Export" style={{ width: "16px", height: "16px", marginBottom: "3px" }} />
        </Comp.Button>
      </div>
      <div className={`${CssClass.card} ${CssClass.tableCard}`}>
        {/* <h3 className={CssClass.tableTitle}>System list</h3> */}
        {/* <hr /> */}
        <SystemListTable
          data={allData}
          onReload={onReloadHandler}
          page={PAGE_NAME}
          module={MODULE_ID}
          onLoading={onLoadingHandler}
          actionAuthority={actionAuthority}
          dataToBeSelect={dataToBeSelect}
        />
      </div>
      <RegisterSystem
        showHide={showAdd}
        dataToBeSelect={dataToBeSelect}
        onHide={showHideRegisterModal}
        onReload={onReloadHandler}
        page={PAGE_NAME}
        module={MODULE_ID}
        onLoading={onLoadingHandler}
      />
      {loading && <Comp.Loading>{loadingText}</Comp.Loading>}
      <Comp.AlertPopup />
    </>
  );
};

export default System;
